import { FormActions } from '../typings'
import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { useEffect, useState } from 'react'

type Status = 'pending' | 'success' | 'fail'

interface Props {
  action: FormActions
  formId: number
}

export const useGetEmbedUrlOnMount = (props: Props) => {
  const { action, formId } = props
  const [status, setStatus] = useState<Status>('pending')
  const [url, setUrl] = useState<string>('')

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const response = await get(
          `${ServiceConfig.baseAPIUrl}/Proposals/url?isAdmin=false`,
        )

        if (response.ok) {
          const json = await response.json()
          const url: string = json

          if (mounted) {
            setUrl(
              url +
                `&formId=${formId}&isEmbedded=embedded${
                  action == FormActions.Notify ? '&isNotify=notify' : ''
                }`,
            )
            setStatus('success')
          }
        } else {
          setStatus('fail')
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [action, formId])

  return [status, url]
}
